<template>
  <!-- <div class="chart-container app-container nohead">
   
  </div> -->
  <div
    id="chart"
    style="width:400px;height:100%;margin-top:30px;"
  ></div>
</template>

<script>

import echarts from 'echarts'
// import resize from '@/views/extend/graphDemo/mixins/resize'

// 获取最大值方法
function calMax (arr) {
  var max = Math.max.apply(null, arr); // 获取最大值方法
  var maxint = Math.ceil(max / 5); // 向上以5的倍数取整
  var maxval = maxint * 5 + 5; // 最终设置的最大值
  return maxval; // 输出最大值
}
// 获取最小值方法
function calMin (arr) {
  var min = Math.min.apply(null, arr); // 获取最小值方法
  var minint = Math.floor(min / 1); // 向下以1的倍数取整
  var minval = minint * 1 - 5; // 最终设置的最小值
  return minval; // 输出最小值
}
export default {
  name: 'extend-graphDemo-echartsBar',
  // mixins: [resize],
  watch: {
    // assDataA: {
    //   handler (newValue, oldValue) {
    //     console.log(newValue, '哈喽哈喽')
    //     this.initChart()
    //   },
    //   deep: true
    // }
  },
  data () {
    return {
      assDataA: [],
      assDataB: [],
      chart: null,
      option: {
        title: {
          text: '堆叠分类',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        toolbox: {
          show: false,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: false },
            dataView: { show: false, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            axisLabel: {
              formatter: function (params) {
                var newParamsName = "";// 最终拼接成的字符串
                var paramsNameNumber = params.length;// 实际标签的个数
                var provideNumber = 11;// 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";// 表示每一次截取的字符串
                    var start = p * provideNumber;// 开始截取的位置
                    var end = start + provideNumber;// 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;// 最终拼成的字符串
                  }

                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '累计里程（km）',
            scale: true,
            nameTextStyle: {
              // padding: [0, 0, 0, 70]
            }
          }
        ],
      }
    }
  },
  mounted () {
    this.initChart()
    // let _this = this;
    // window.addEventListener('resize', function () {
    //   // _this.echart 指的要改变大小的图表
    //   _this.initChart.resize();
    // });
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    // mileageAll-数量 dateAll-时间
    initData (data) {
      console.log('获取到的数据@', data)
      // const dataArr = []
      // dataArr.push(data)
      // for (var i = 0; i < dataArr.length; i++) {
      //   const arrA = data.dateAll.split(',')
      //   const arrB = data.mileageAll.split(',')
      //   var this_ = this
      //   this_.assDataA = []
      //   this_.assDataB = []
      //   for (var iw = 0; iw < arrB.length; iw++) {
      //     (function (iw) {
      //       setTimeout(function timer () {
      //         this_.assDataB.push(arrB[iw])
      //         console.log('arrB[iw]', this_.assDataB)
      //       }, 500 * iw);
      //     })(iw);
      //   }
      //   for (var iq = 0; iq < arrA.length; iq++) {
      //     (function (iq) {
      //       setTimeout(function timer () {
      //         this_.assDataA.push(arrA[iq])
      //         console.log('arrA[iq]', this_.assDataA)
      //       }, 500 * iq);
      //     })(iq);
      //   }
      // }

      //重置option
      // let arr = this_.assDataB   
      let arr = data.mileageAll.split(',')
      this.option.title.text = ""
      this.option.legend.data = []
      this.option.legend.data = ['里程']
      let max = calMax(arr)
      let min = calMin(arr)
      let interval = Math.floor((max - min) / 6)
      this.option.yAxis[0].max = max
      this.option.yAxis[0].min = min
      this.option.yAxis[0].interval = interval

      this.option.xAxis = [
        {
          type: 'category',
          data: data.dateAll.split(',')
        }
      ],

        this.option.series = [{
          name: '里程',
          yAxisIndex: 0,
          type: 'line',
          data: arr,
          symbol: "none",
        }]
      // console.log(data,'重置option')
      this.initChart()
    },
    initChart () {
      console.log(this.option, 'initChart')
      this.chart = echarts.init(document.getElementById('chart'))

      this.chart.setOption(this.option)
    }
  }
}
</script>
